import { render, staticRenderFns } from "./image-box.vue?vue&type=template&id=48983da7&scoped=true&"
import script from "./image-box.vue?vue&type=script&lang=ts&"
export * from "./image-box.vue?vue&type=script&lang=ts&"
import style0 from "./image-box.vue?vue&type=style&index=0&id=48983da7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48983da7",
  null
  
)

export default component.exports